import React, { Component, Fragment } from 'react';
import { Container, Row, Col, Input, Label, Button, Form, FormGroup } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'
import PermissionWrapper from '../../auth/PermissionWrapper';
import ConfirmButton from '../Modal/ConfirmButton';

class FormSelects extends Component {

    standardRow = (formSelect) => {
        this.props.info('FormSelects.js/standardRow (formSelect)', formSelect);
        return (
            <Row className="adminRow pointer" onClick={() => this.props.onEdit(formSelect.formSelectId)}>
                <Col md={4} className="text-left">
                    <FontAwesomeIcon icon={(formSelect['active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((formSelect['active']) ? 'iconActive' : 'iconInactive')} />
                    {formSelect['name']}
                </Col>
                <Col md={7} className="text-left"></Col>
            </Row>
        )
    }

    editRow = (formSelect) => {
        this.props.log('FormSelects.js/editRow (formSelect)', formSelect);
        return (<>
            <Row key={"edit" + formSelect.formSelectId} className={"adminRow activeTab"}>
                <Col md={9} className={"text-left pl-5"}>
                    <Form inline className="align-items-start">
                        <FormGroup className="pr-2">
                            <Input
                                placeholder="Name"
                                type="text"
                                id={"edit-name" + formSelect.formSelectId}
                                name="name"
                                value={this.props.isFieldNull(this.props.editFormSelect.name)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                        </FormGroup>
                        <FormGroup className="pr-2">
                            <Input
                                placeholder="Options"
                                type="textarea"
                                id={"edit-options"}
                                name="options"
                                rows={6}
                                value={this.props.isFieldNull(this.props.editFormSelect.options)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                        </FormGroup>
                        <FormGroup className="pr-2">
                            <Input
                                placeholder="Default"
                                type="text"
                                id={"edit-default" + formSelect.formSelectId}
                                name="default"
                                value={this.props.isFieldNull(this.props.editFormSelect.default)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                        </FormGroup>
                        <FormGroup className="px-2">
                            <Input
                                type="checkbox"
                                id={"edit-active" + formSelect.formSelectId}
                                name="active"
                                checked={this.props.isFieldNull(this.props.editFormSelect.active, true)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                            <Label for={"edit-active" + formSelect.formSelectId}>
                                Active
                            </Label>
                        </FormGroup>
                    </Form>
                </Col>
                <Col md={3} className="text-right">
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Form Selects">
                        <Button className="mx-1" color="success" onClick={() => this.props.handleEdit()} title="Edit Form Select">
                            <FontAwesomeIcon icon={faCheck} />
                        </Button>
                    </PermissionWrapper>
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Form Selects">
                        <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(formSelect.formSelectId)}>
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </ConfirmButton>
                    </PermissionWrapper>
                    <Button className="mx-1" color="secondary" onClick={() => this.props.handleCancel()} title="Cancel">
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </Col>
                <Col md={1}></Col>
                <Col md={2} className="text-right py-3 px-0">
                    Form Select Options
                </Col>
                <Col md={4} className="text-left py-3">
                    {[...this.props.formFields].filter(formField => formField.type === 'select').map(formField => {
                        const thisFormFields = this.props.editFormSelect.formFields;
                        const newOrder = (thisFormFields.findIndex(item => item.formFieldId === formField.formFieldId) > -1) ?
                            thisFormFields[thisFormFields.findIndex(item => item.formFieldId === formField.formFieldId)].order : formField.order * 100000;
                        return ({
                            ...formField,
                            order: newOrder
                        })
                    })
                        .sort((a, b) => a.order - b.order)
                        .map(formField => (
                            <Row className="fieldRow" key={formField.formFieldId}>
                                <Col md={10}>
                                    <Label key={formField.formFieldId} for={"formField_" + formField.formFieldId}>
                                        <Input
                                            type="checkbox"
                                            name="formFields"
                                            id={"formField_" + formField.formFieldId}
                                            checked={this.props.isFieldNull(this.props.editFormSelect.formFields.findIndex(i => i.formFieldId === parseInt(formField.formFieldId)) > -1, true)}
                                            onChange={e => this.props.onChange(e, 'edit')}
                                        />{formField.field}
                                    </Label>
                                </Col>
                            </Row>
                        ))}
                </Col>
            </Row>
        </>
        )
    }

    addRow = () => {
        this.props.info('FormSelects.js/addRow');
        return (
            <Row className="py-4 text-left align-items-bottom ">
                <Col md={10} className="pl-5">
                    <Form inline className="align-items-start">
                        <FormGroup className="pr-2">
                            <Input
                                placeholder="Name"
                                type="text"
                                id={"form-select-add-name"}
                                name="name"
                                value={this.props.isFieldNull(this.props.newFormSelect.name)}
                                onChange={e => this.props.onChange(e, '')} />
                        </FormGroup>
                        <FormGroup className="pr-2">
                            <Input
                                placeholder="Options"
                                type="textarea"
                                id={"form-select-add-options"}
                                name="options"
                                rows={6}
                                value={this.props.isFieldNull(this.props.newFormSelect.options)}
                                onChange={e => this.props.onChange(e, '')} />
                        </FormGroup>
                        <FormGroup className="pr-2">
                            <Input
                                placeholder="Default"
                                type="text"
                                id={"form-select-add-default"}
                                name="default"
                                value={this.props.isFieldNull(this.props.newFormSelect.default)}
                                onChange={e => this.props.onChange(e, '')} />
                        </FormGroup>
                        <FormGroup className="px-2">
                            <Input
                                type="checkbox"
                                id={"form-select-add-active"}
                                name="active"
                                checked={this.props.isFieldNull(this.props.newFormSelect.active, true)}
                                onChange={e => this.props.onChange(e, '')} />
                            <Label for={"form-select-add-active"}>
                                Active
                            </Label>
                        </FormGroup>
                    </Form>
                </Col>
                <Col md={2} className="text-right">
                    <Button
                        disabled={this.props.newFormSelect.name === ''}
                        color="primary"
                        onClick={() => this.props.handleAdd()}
                    >Add Select</Button>
                </Col>
            </Row>
        )
    }

    render() {
        this.props.info('FormSelects.js/render');
        return (
            <Container className="adminContainer" fluid>
                {this.props.formSelects.map(formSelect => (
                    <Fragment key={formSelect.formSelectId}>{this.props.editFormSelect.formSelectId === formSelect.formSelectId ?
                        <>{this.editRow(formSelect, true)}
                            {this.addRow()}
                        </> : this.standardRow(formSelect, true)}</Fragment>
                ))}
                <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Form Selects">
                    {this.addRow(true)}
                </PermissionWrapper>
            </Container>
        );

    }
}

export default FormSelects;
